<template>
  <div class="chat waajo-chat-room">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <left-sidebar></left-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper" style="min-height: 100dvh;
      left: 0;
      padding-top: 60px;">
        <!-- Chat Main Row -->
        <div class="chat-main-row">
          <LightBox :ref="'lightbox'" :showLightBox="false" v-if="groupMessageMedia.length > 0"
            :media="groupMessageMedia"></LightBox>
          <!-- Chat Main Wrapper -->
          <div class="chat-main-wrapper" :class="{ 'waajo-contact-hidden': !showContactPanel }">
            <div class="col-lg-9 message-view task-view">
              <div class="chat-window">
                <div class="fixed-header" v-if="activeRoomId != ''">
                  <div class="waajo-chat-header">
                    <div class="waajo-chat-contact">
                      <a href="javascript:void(0)" class="waajo-chat-avatar" :title="avatarArr.room_title">
                        <img
                          src="@/assets/profiles/avatar-02.jpg"
                          alt
                          v-if="avatarArr.room_photo == ''"
                        />
                        <img v-lazy="avatarArr.room_photo" alt v-else />
                        <span class="waajo-online-dot"></span>
                      </a>

                      <div class="waajo-chat-contact-info">
                        <div class="waajo-chat-name-row">
                          <h5>{{ avatarArr.room_title }}</h5>
                          <span class="waajo-channel-badge">
                            <i class="fa fa-whatsapp"></i>
                            WhatsApp
                          </span>
                        </div>
                        <div class="waajo-chat-meta">
                          <span v-if="roomDetail.is_group == 1">
                            <i class="fa fa-users"></i>
                            Grup WhatsApp
                          </span>
                          <span v-else>
                            <i class="fa fa-phone"></i>
                            {{ getWhatsappNumberFromJid(roomDetail.room_number) }}
                          </span>
                          <span v-if="roomDetail.provider" class="waajo-chat-provider">
                            {{ roomDetail.provider }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="waajo-chat-header-actions">
                      <div class="waajo-chat-search">
                        <i class="fa fa-search"></i>
                        <input
                          type="text"
                          placeholder="Cari pesan..."
                          v-model="keywords"
                          @keyup.enter="searchHandler"
                          @change="searchHandler"
                        />
                        <button
                          @click="searchHandler"
                          type="button"
                          title="Cari pesan"
                        >
                          <i class="fa fa-arrow-right"></i>
                        </button>
                      </div>

                      <button
                        type="button"
                        class="waajo-header-icon waajo-contact-toggle"
                        :title="showContactPanel ? 'Sembunyikan info kontak' : 'Tampilkan info kontak'"
                        @click.prevent="toggleContactPanel"
                      >
                        <i :class="showContactPanel ? 'fa fa-user' : 'fa fa-user-o'"></i>
                      </button>

                      <div class="dropdown dropdown-action waajo-header-status">
                        <a
                          aria-expanded="false"
                          data-toggle="dropdown"
                          class="waajo-status-btn dropdown-toggle"
                          href="#"
                          v-if="isNotResolveData == true"
                        >
                          <i class="fa fa-dot-circle-o"></i>
                          Terbuka
                        </a>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          v-if="isNotResolveData == true"
                        >
                          <a class="dropdown-item" @click.prevent="setResolve" href="#">
                            <i class="fa fa-check-circle"></i>
                            Tandai Selesai
                          </a>
                        </div>
                        <span class="waajo-status-btn is-resolved" v-else>
                          <i class="fa fa-check-circle"></i>
                          Selesai
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeRoomId == ''" class="waajo-chat-empty">
                  <div class="waajo-chat-empty-icon">
                    <i class="fa fa-comments-o"></i>
                  </div>
                  <h4>Pilih percakapan</h4>
                  <p>
                    Pilih kontak dari daftar di sebelah kiri untuk mulai
                    mengobrol.
                  </p>
                </div>

                <div class="chat-contents" v-if="activeRoomId != ''">
                  <div class="chat-content-wrap" v-if="activeRoomId != ''">
                    <div class="chat-wrap-inner">
                      <infinite-loading v-if="!loadingMessage" spinner="spiral" @infinite="infiniteHandler">
                        <div slot="spinner">Memuat...</div>
                        <!-- <div slot="no-more">Tidak ada pesan lagi</div> -->
                        <div slot="no-more">
                          <span
                            v-if="(this.hotChatParam.totalRecords > 0 && this.hotChatParam.rendered >= this.hotChatParam.totalRecords)">Tidak
                            ada pesan lagi</span>
                          <span v-if="(this.hotChatParam.totalRecords == 0)">Tidak ada pesan lagi</span>
                          <span v-if="(this.hotChatParam.totalRecords > 0 && this.hotChatParam.rendered == 0)">Tidak ada
                            pesan lagi</span>
                        </div>
                        <div slot="no-results">
                          <span v-if="(this.hotChatParam.totalRecords == 0)">Pesan tidak ditemukan</span>
                          <span v-else>Tidak ada pesan lagi</span>
                        </div>
                      </infinite-loading>

                      <div class="chat-box">
                        <div class="chats" v-if="loadingMessage || loadingSwitchRoom">
                          <Skeleton :count="3" />
                        </div>
                        <div class="chats" :style="'background: url(\'' + whatsappBackground + '\');'">
                          <div
                            v-for="group in groupChatByDate"
                            :key="group.key"
                            class="chat-date-group"
                          >
                            <div
                              class="chat-date-separator-row"
                              :id="'chat-' + group.key"
                            >
                              <span class="chat-date-separator">{{ group.label }}</span>
                            </div>
                            <div
                              v-for="(row, rowIndex) in group.messages"
                              :key="row.id || row.message_id || rowIndex"
                              class="chat-message-row"
                            >
                              <div class="chat chat-right" v-if="row.from_me == 1">
                                <div class="chat-body">
                                  <template v-if="row.is_deleted == 1">
                                    <div class="chat-bubble">
                                      <div class="chat-content">
                                        <i class="text-muted">Anda menghapus pesan ini</i>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="chat-bubble" v-if="row.message_type == 'document' || row.message_type == 'video' || row.message_type == 'file'">
                                      <div class="chat-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <small class="text-info">
                                                      <i>
                                                        <b v-if="row.quoted_message.from_me == 0">{{
                                                          row.quoted_message.message_name }}</b>
                                                        <b v-else>Anda</b>
                                                      </i>
                                                    </small>
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'document'">
                                                      <i class="fa fa-file-o"></i> dokumen
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-film"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <chat-media :row="row" @open="openGallery"></chat-media>
                                        <p
                                          v-if="row.message && row.message != '-'"
                                          class="waajo-media-caption"
                                          v-html="messageFilter(row.message)"
                                          v-linkified
                                        ></p>
                                        <span class="chat-time">
                                          <template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template> {{ row.timeMinuteHour }}</span>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <!-- <li>
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li> -->
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="chat-bubble" v-else-if="row.message_type == 'image'">
                                      <div class="chat-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-film"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div class="chat-img-group clearfix">
                                          <chat-media :row="row" @open="openGallery"></chat-media>

                                          <p v-html="messageFilter(row.message)" v-if="row.message != ''" v-linkified>
                                          </p>
                                          <span class="chat-time">
                                            <template v-if="row.is_edit == 1">
                                              <i>Diedit</i>
                                            </template>
                                            {{ row.timeMinuteHour }}
                                            <i title="Pesan sedang dikirim" class="text-info fa fa-clock-o"
                                              v-if="row.status == 1"></i>
                                            <i title="Pesan gagal terkirim" class="text-danger fa fa-warning"
                                              v-if="row.status == 0"></i>
                                          </span>
                                        </div>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <!-- <li>
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li> -->
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="chat-bubble"
                                      v-else-if="row.message_type == 'text' || row.message_type == 'sticker' || row.message_type == 'location'">
                                      <div class="chat-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <small class="text-info">
                                                      <i>
                                                        <b v-if="row.quoted_message.from_me == 0">{{
                                                          row.quoted_message.message_name }}</b>
                                                        <b v-else>Anda</b>
                                                      </i>
                                                    </small>
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-file-image-o"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <small class="text-info" v-if="row.from_me == 0 && row.is_group == 1">
                                          <i>
                                            <b>{{ row.participant_name }}</b>
                                          </i>
                                        </small>
                                        <img
                                          style="max-width:50px;"
                                          :src="row.message_media"
                                          loading="lazy"
                                          v-if="row.message_type == 'sticker'"
                                        />
                                        <p v-if="row.message_type == 'text'" v-html="messageFilter(row.message)"
                                          v-linkified></p>
                                        <p v-if="row.message_type == 'location'" v-linkified>{{ row.message }}</p>
                                        <span class="chat-time">
                                          <template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template>
                                          <i title="Pesan sedang dikirim" class="text-info fa fa-clock-o"
                                            v-if="row.status == 1"></i>
                                          <i title="Pesan gagal terkirim" class="text-danger fa fa-warning"
                                            v-if="row.status == 0"></i>
                                          {{ row.timeMinuteHour }}
                                        </span>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <li v-if="row.status >= 2">
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li>
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div v-else class="chat-bubble">
                                      <div class="chat-content">
                                        <p class="text-muted">
                                          <i>Jenis pesan ini belum dapat ditampilkan.</i>
                                        </p>
                                        <span class="chat-time">
                                          <template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template>
                                          {{ row.timeMinuteHour }}</span>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                              <div class="chat chat-left" v-if="row.from_me == 0">
                                <div class="chat-avatar">
                                  <a href="javascript:void(0)" class="avatar">
                                    <img src="@/assets/profiles/avatar-02.jpg" alt v-if="avatarArr.room_photo == ''" />
                                    <img v-lazy="avatarArr.room_photo" alt v-else />
                                  </a>
                                </div>
                                <div class="chat-body">
                                  <template v-if="row.is_deleted == 1">
                                    <div class="chat-bubble">
                                      <div class="chat-content">
                                        <i class="text-muted">Pesan ini telah dihapus</i>
                                        <!-- <p v-if="row.deleted_agent_id != ''">
                                          <i class="text-muted">by Agent</i>
                                        </p> -->
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <template v-if="row.is_forwarded == 1">
                                      <small class="text-muted"><i>⤵️Diteruskan</i></small>
                                    </template>
                                    <div class="chat-bubble"
                                      v-if="row.message_type == 'document' || row.message_type == 'video' || row.message_type == 'file'">
                                      <div class="chat-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <small class="text-info">
                                                      <i>
                                                        <b v-if="row.quoted_message.from_me == 0">{{
                                                          row.quoted_message.message_name }}</b>
                                                        <b v-else>Anda</b>
                                                      </i>
                                                    </small>
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'document'">
                                                      <i class="fa fa-file-o"></i> dokumen
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-file-image-o"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <small class="text-info" v-if="row.from_me == 0 && row.is_group == 1">
                                          <i>
                                            <b>{{ row.participant_name }}</b>
                                          </i>
                                        </small>
                                        <chat-media :row="row" @open="openGallery"></chat-media>
                                        <p
                                          v-if="row.message && row.message != '-'"
                                          class="waajo-media-caption"
                                          v-html="messageFilter(row.message)"
                                          v-linkified
                                        ></p>
                                        <span class="chat-time"><template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template> {{ row.timeMinuteHour }}</span>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <li>
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li>
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="chat-bubble" v-else-if="row.message_type == 'image'">
                                      <div class="chat-content img-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <small class="text-info">
                                                      <i>
                                                        <b v-if="row.quoted_message.from_me == 0">{{
                                                          row.quoted_message.message_name }}</b>

                                                        <b v-else>Anda</b>
                                                      </i>
                                                    </small>
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-film"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <small class="text-info" v-if="row.from_me == 0 && row.is_group == 1">
                                          <i>
                                            <b>{{ row.participant_name }}</b>
                                          </i>
                                        </small>
                                        <div class="chat-img-group clearfix">
                                          <chat-media :row="row" @open="openGallery"></chat-media>
                                          <p v-html="messageFilter(row.message)"
                                            v-if="row.message != '' && row.message != '-'" v-linkified></p>
                                          <span class="chat-time"><template v-if="row.is_edit == 1">
                                              <i>Diedit</i>
                                            </template> {{ row.timeMinuteHour }}</span>
                                        </div>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <li>
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li>
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      v-else-if="row.message_type == 'text' || row.message_type == 'sticker' || row.message_type == 'location'"
                                      class="chat-bubble">
                                      <div class="chat-content">
                                        <div class="chat-file-desc" v-if="typeof row.quoted_message != 'undefined'">
                                          <div class="experience-box">
                                            <ul class="experience-list">
                                              <li>
                                                <div class="experience-user">
                                                  <div class="before-circle"></div>
                                                </div>
                                                <div class="experience-content" style="margin-left:20px;">
                                                  <div style="margin-right:5px;margin-left:5px;"
                                                    class="timeline-content">
                                                    <small class="text-info">
                                                      <i>
                                                        <b v-if="row.quoted_message.from_me == 0">{{
                                                          row.quoted_message.message_name }}</b>
                                                        <b v-else>Anda</b>
                                                      </i>
                                                    </small>
                                                    <p v-if="row.quoted_message.message_type == 'text'">
                                                      {{ row.quoted_message.message }}</p>
                                                    <p
                                                      v-if="row.quoted_message.message_type == 'image' || row.quoted_message.message_type == 'sticker'">
                                                      <i class="fa fa-file-image-o"></i> gambar
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'video'">
                                                      <i class="fa fa-film"></i> video
                                                    </p>
                                                    <p v-if="row.quoted_message.message_type == 'file'">
                                                      <i class="fa fa-file-image-o"></i> berkas
                                                    </p>
                                                  </div>
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <small class="text-info" v-if="row.from_me == 0 && row.is_group == 1">
                                          <i>
                                            <b>{{ row.participant_name }}</b>
                                          </i>
                                        </small>
                                        <img
                                          style="max-width:50px;"
                                          :src="row.message_media"
                                          loading="lazy"
                                          v-if="row.message_type == 'sticker'"
                                        />
                                        <p v-if="row.message_type == 'text'" v-html="messageFilter(row.message)"
                                          v-linkified></p>
                                        <p v-if="row.message_type == 'location'" v-linkified>{{ row.message }}</p>
                                        <span class="chat-time"><template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template> {{ row.timeMinuteHour }}</span>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <li>
                                            <a @click="replyMessage(row.id)" href="javascript:void(0)" id="a-reply-msg"
                                              class="edit-msg">
                                              <i :class="'fa fa-reply reply#' + row.id"></i>
                                            </a>
                                          </li>
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div v-else class="chat-bubble">
                                      <div class="chat-content">
                                        <p class="text-muted">
                                          <i>Jenis pesan ini belum dapat ditampilkan.</i>
                                        </p>
                                        <span class="chat-time">
                                          <template v-if="row.is_edit == 1">
                                            <i>Diedit</i>
                                          </template>
                                          {{ row.timeMinuteHour }}</span>
                                      </div>
                                      <div class="chat-action-btns">
                                        <ul>
                                          <li><a @click="revokeMessage(row.message_id, row.message_number)"
                                              href="javascript:void(0)" class="del-msg"><i class="fa fa-trash-o"></i>
                                            </a></li>
                                        </ul>
                                      </div>
                                    </div>
                                  </template>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-footer" v-if="activeRoomId != ''">
                  <div
                    class="waajo-composer"
                    :class="{ 'waajo-composer-dragging': isDraggingFiles }"
                    @dragenter.prevent="handleComposerDragEnter"
                    @dragover.prevent="handleComposerDragOver"
                    @dragleave.prevent="handleComposerDragLeave"
                    @drop.prevent="handleComposerDrop"
                  >
                    <div v-if="isDraggingFiles" class="waajo-composer-drop-overlay">
                      <i class="fa fa-cloud-upload"></i>
                      <strong>Lepaskan berkas untuk dilampirkan</strong>
                      <small>Gambar, video, atau dokumen</small>
                    </div>

                    <div class="waajo-composer-quick">
                      <quick-reply
                        @select="applyQuickReply"
                        @quick-reply-error="handleQuickReplyError"
                      />
                    </div>

                    <div v-if="isReplyTo" class="waajo-reply-preview">
                      <div class="waajo-reply-content">
                        <div class="waajo-reply-label">
                          <i class="fa fa-reply"></i>
                          <strong
                            v-if="isReplyMessage.is_group == 1 && isReplyMessage.participant_name != ''"
                          >
                            {{ isReplyMessage.participant_name }}
                          </strong>
                          <strong
                            v-else-if="isReplyMessage.is_group == 1 && isReplyMessage.participant_number != ''"
                          >
                            {{ isReplyMessage.participant_number }}
                          </strong>
                          <strong
                            v-else-if="isReplyMessage.is_group == 0 && isReplyMessage.from_me == 0"
                          >
                            {{ isReplyMessage.message_name }}
                          </strong>
                          <strong v-else>Anda</strong>
                        </div>
                        <p>{{ isReplyMessage.message }}</p>
                      </div>
                      <button
                        type="button"
                        class="waajo-reply-close"
                        @click.prevent="cancelReplyMessage(true)"
                        title="Batalkan balasan"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>

                    <div class="waajo-composer-main">
                      <textarea
                        v-autogrow
                        ref="messagebox"
                        class="form-control waajo-message-input"
                        v-model="textMessage"
                        placeholder="Tulis pesan..."
                        rows="1"
                        @mouseup="showFormatMenu"
                        @keyup="showFormatMenu"
                        @keydown="inputHandler"
                        @paste="handleComposerPaste"
                      ></textarea>

                      <button
                        type="button"
                        class="waajo-send-btn"
                        :disabled="!canSendMessage"
                        @click.prevent="textMessageHandler"
                        title="Kirim pesan"
                      >
                        <i class="fa fa-paper-plane"></i>
                        <span>Kirim</span>
                      </button>
                    </div>

                    <div class="waajo-composer-toolbar">
                      <div class="waajo-composer-tools">
                        <div class="waajo-emoji-host">
                          <Emoji
                            :open="emojiAttr.open"
                            :width="emojiAttr.width"
                            :height="emojiAttr.height"
                            searchLabel="Cari emoji..."
                            @click="selectedEmoji"
                          />
                        </div>

                        <button
                          type="button"
                          class="waajo-tool-btn"
                          title="Emoji"
                          @click="emojiToggle()"
                        >
                          <img src="@/assets/emoji.png" alt="" />
                        </button>

                        <button
                          type="button"
                          class="waajo-tool-btn"
                          id="btnDragFiles"
                          data-toggle="modal"
                          data-target="#drag_files"
                          title="Lampiran"
                        >
                          <i class="fa fa-paperclip"></i>
                        </button>

                        <a-dropdown>
                          <button type="button" class="waajo-tool-btn">
                            <i class="fa fa-code"></i>
                            <span>Templat</span>
                            <i class="fa fa-angle-down"></i>
                          </button>
                          <a-menu slot="overlay">
                            <a-menu-item
                              v-for="temp in templateMessage"
                              :key="temp"
                            >
                              <a @click.prevent="addTemplateToMesage(temp)">
                                {{ temp }}
                              </a>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>

                        <span class="waajo-tool-divider"></span>

                        <button
                          type="button"
                          class="waajo-tool-btn waajo-format-btn"
                          title="Tebal"
                          @click="applyFormat('*')"
                        >
                          <b>B</b>
                        </button>
                        <button
                          type="button"
                          class="waajo-tool-btn waajo-format-btn"
                          title="Miring"
                          @click="applyFormat('_')"
                        >
                          <i>I</i>
                        </button>
                        <button
                          type="button"
                          class="waajo-tool-btn waajo-format-btn"
                          title="Coret"
                          @click="applyFormat('~')"
                        >
                          <s>S</s>
                        </button>
                        <button
                          type="button"
                          class="waajo-tool-btn waajo-format-btn"
                          title="Monospace"
                          @click="applyFormat('```')"
                        >
                          <span class="waajo-mono">M</span>
                        </button>

                        <AIComponent class="waajo-ai-tool" v-model="textMessage" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Chats View -->

            <!-- Chat Right Sidebar -->
            <right-sidebar :class="{ 'waajo-contact-hidden': !showContactPanel }"></right-sidebar>
            <!-- /Chat Right Sidebar -->
          </div>
          <!-- /Chat Main Wrapper -->
        </div>
        <!-- /Chat Main Row -->
        <!-- Drogfiles Modal -->
        <div id="drag_files" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Kirim Lampiran [maksimal {{ maximumUpload }} berkas]</h5>
                <button id="btnCloseUploadFiles" type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                class="modal-body"
                :class="{ 'waajo-attachment-drop-active': isDraggingFiles }"
                @dragenter.prevent="isDraggingFiles = true"
                @dragover.prevent
                @dragleave.prevent="handleAttachmentDragLeave"
                @drop.prevent="handleAttachmentDrop"
              >
                <div v-if="files.length" class="waajo-attachment-summary">
                  <div>
                    <strong>{{ files.length }} / {{ maximumUpload }} berkas</strong>
                    <span>Total {{ formatSizes(totalAttachmentSize) }} dari 10 MB</span>
                  </div>
                  <span
                    class="waajo-attachment-summary-badge"
                    :class="{ 'is-over': totalAttachmentSize > maxUploadSize }"
                  >
                    {{ totalAttachmentSize > maxUploadSize ? "Melebihi batas" : "Siap dikirim" }}
                  </span>
                </div>

                <form id="js-upload-form">
                  <div v-show="files.length == 0" class="upload-drop-zone" id="drop-zone">
                    <i class="fa fa-cloud-upload fa-2x"></i>
                    <span class="upload-text">
                      <label :for="name">
                        Tarik dan lepas berkas di sini
                      </label>
                      <small>Maksimal 3 berkas, total 10 MB</small>
                    </span>
                  </div>
                  <h4 v-if="files.length">Berkas dipilih</h4>
                  <ul class="upload-list waajo-attachment-list" v-if="files.length">
                    <li v-for="file in files" :key="file.id" class="file-list waajo-attachment-item">
                      <div class="waajo-attachment-preview">
                        <img
                          v-if="isImageAttachment(file)"
                          :src="file.thumb || file.blob"
                          :alt="file.name"
                        />
                        <video
                          v-else-if="isVideoAttachment(file) && file.blob"
                          :src="file.blob"
                          muted
                          preload="metadata"
                        ></video>
                        <span v-else class="waajo-attachment-icon">
                          <i :class="getAttachmentIcon(file)"></i>
                        </span>
                      </div>

                      <div class="waajo-attachment-info">
                        <div class="waajo-attachment-name">{{ file.name }}</div>
                        <div class="waajo-attachment-meta">
                          <span>{{ getAttachmentLabel(file) }}</span>
                          <span>{{ formatSizes(file.size) }}</span>
                          <span v-if="file.edited" class="waajo-attachment-edited">
                            <i class="fa fa-pencil"></i> Diedit
                          </span>
                        </div>
                        <div v-if="file.error" class="waajo-attachment-error">
                          <i class="fa fa-exclamation-circle"></i>
                          {{ file.error }}
                        </div>
                        <div v-else-if="file.sending" class="waajo-attachment-status">
                          <i class="fa fa-spinner fa-spin"></i>
                          Mengirim...
                        </div>
                        <div v-else-if="file.success" class="waajo-attachment-status is-success">
                          <i class="fa fa-check-circle"></i>
                          Terkirim
                        </div>
                        <div v-if="isGifAttachment(file)" class="waajo-attachment-editor-note">
                          GIF animasi tidak diedit agar animasinya tetap utuh.
                        </div>
                      </div>

                      <div class="waajo-attachment-actions">
                        <button
                          v-if="isImageAttachment(file)"
                          type="button"
                          class="waajo-attachment-edit"
                          :title="getImageEditorTitle(file)"
                          :disabled="!canEditImageAttachment(file) || file.sending"
                          @click.prevent="openImageEditor(file)"
                        >
                          <i class="fa fa-pencil"></i>
                          <span>Edit</span>
                        </button>
                        <button
                          type="button"
                          class="waajo-attachment-remove"
                          title="Hapus lampiran"
                          :disabled="file.sending"
                          @click.prevent="removeAttachment(file)"
                        >
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </form>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="submit-section waajo-attachment-composer">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <label class="btn btn-outline-secondary waajo-attachment-pick">
                            <input
                              type="file"
                              class="waajo-attachment-input"
                              multiple
                              :accept="accept"
                              @change="handleAttachmentFileInput"
                            />
                            <img src="@/assets/attachment.png" alt />
                            <span>Pilih Berkas</span>
                          </label>
                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {{ uploadMessageType || "Opsi" }}
                          </button>
                          <div class="dropdown-menu">
                            <a
                              @click.prevent="updateMessageTypeCurrent(opt)"
                              class="dropdown-item"
                              href="#"
                              v-for="(opt, index) in messageTypeOptionsUpload"
                              :key="index"
                            >
                              <i
                                class="text-success fa fa-check-circle"
                                v-if="uploadMessageType == opt"
                              ></i>
                              {{ opt }}
                            </a>
                          </div>
                        </div>

                        <input
                          type="text"
                          class="form-control"
                          placeholder="Keterangan / caption"
                          aria-label="Keterangan"
                          aria-describedby="basic-addon2"
                          v-model="caption"
                          @keydown="inputFileHandler"
                        />

                        <div class="input-group-append">
                          <button
                            @click.prevent="filesMessageHandler"
                            class="btn btn-primary"
                            type="button"
                            :disabled="
                              files.length === 0 ||
                              totalAttachmentSize > maxUploadSize
                            "
                          >
                            <i class="fa fa-paper-plane"></i>
                            Kirim
                          </button>
                        </div>
                      </div>
                      <small class="waajo-attachment-caption-hint">
                        Caption akan disertakan pada gambar, video, atau dokumen.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="alert alert-warning waajo-attachment-rules">
                      <ul>
                        <li>
                          Format: {{ extensions.replace(/,/g, ", ") }}
                        </li>
                        <li>Maksimal 3 berkas dan total 10 MB per pengiriman.</li>
                        <li v-if="uploadMessageType == 'video'">
                          Pengiriman video mengikuti dukungan endpoint backend aktif.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <image-editor
          v-if="imageEditorOpen"
          :key="imageEditorAttachmentId"
          :file="imageEditorFile"
          :file-name="imageEditorName"
          @cancel="closeImageEditor"
          @done="applyEditedImage"
        />

        <!-- /Add Group Modal -->
        <!-- Add Chat User Modal -->
        <direct />
        <broadcast />
        <filters-form />
        <!-- /Add Chat User Modal -->
        <!-- Share Files Modal -->

 
        <!-- /Share Files Modal -->
      </div>
    </div>
  </div>
</template>
<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";

import OffCanvas from "@/components/TextReply/offCanvas.vue";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import LightBox from "vue-image-lightbox";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";
import {
  formatDate,
  formatDateForMessage,
  getMessageDate,
  groupMessagesByChatDate,
  getWhatsappNumberFromJid,
  formatSizes
} from "@/utils/helper";
import { uuid } from "vue-uuid";
import LayoutHeader from "@/components/layouts/Header.vue";
import LeftSidebar from "./LeftSidebar.vue";
import RightSidebar from "./RightSidebar.vue";
import Direct from "./direct.vue";
import Broadcast from "./broadcast.vue";
import FiltersForm from "./components/filters.vue";
import QuickReply from "./components/quickReply.vue";
import ChatMedia from "./components/ChatMedia.vue";
import ImageEditor from "./components/ImageEditor.vue";
import autogrow from './autogrow.js'
export default {
  directives: {
    autogrow
  },
  components: {
    FiltersForm,
    OffCanvas,
    QuickReply,
    ChatMedia,
    ImageEditor,
    Broadcast,
    Direct,
    Emoji: VueChatEmoji,
    LayoutHeader,
    LeftSidebar,
    RightSidebar,
    InfiniteLoading,
    Skeleton,
    LightBox,
    AIComponent: () => import("@/components/AIComponent"),
  },
  data() {
    return { 
      showMenu: false,
      menuPos: { x: 0, y: 0 },
      selection: { start: 0, end: 0 },
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isNotResolveData: true,
      // headers: {
      //   "X-Auth-Token": "Bearer " + this.getXAuthToken,
      //   "X-Auth-Agent": "Bearer " + this.getXAuthAgent
      // },
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: false,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICoreV2() +
        "/omni/room/send-file",
      // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-filemq",
      // uploadUrl:
      // process.env.VUE_APP_BASE_API +
      // this.APICore() +
      // "/omni/room/only-upload-file",
      // uploadMessageType: "image",
      maximumUpload: 3,
      // Backend maxUploadSize adalah 10000 KB; gunakan batas yang tidak
      // melebihi batas server tersebut.
      maxUploadSize: 10 * 1000 * 1000,
      accept:
        "image/jfif,image/png,image/gif,image/jpeg,image/webp,.jfif,.jpg,.jpeg,.png,.gif,.webp,.m4v,.mp4,.zip,.pdf,.xls,.xlsx,.doc,.docx",
      extensions: "jfif,gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx,doc,docx,m4v,mp4",
      supportedImageExtensions: ["gif", "jpg", "jpeg", "png", "webp"],
      supportedVideoExtensions: ["m4v", "mp4"],
      supportedDocumentExtensions: [
        "jfif",
        "gif",
        "jpg",
        "jpeg",
        "png",
        "webp",
        "zip",
        "pdf",
        "xls",
        "xlsx",
        "doc",
        "docx",
        "m4v",
        "mp4"
      ],
      minSize: 1,
      size: 10 * 1000 * 1000,
      files: [],
      imageEditorOpen: false,
      imageEditorFile: null,
      imageEditorName: "",
      imageEditorAttachmentId: null,
      isDraggingFiles: false,
      initScrollTop: 0,
      loadingSwitchRoom: false,
      activeRoomReady: false,
      roomSwitchToken: 0,
      messageListRequestId: 0,
      chatDateNow: Date.now(),
      loadingMessage: false,
      counter: 0,
      isReplyTo: false,
      isReplyMessage: {},
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: ""
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      textMessageData: [],
      timestamp: Date.now(),
      textMessage: "",
      isSearch: false,
      showContactPanel: typeof window !== "undefined" ? window.innerWidth > 991 : true,
      // roomData: [],
      loading: false,
      currentState: null,
      loadColdChats: false,
      activeClass: "active",
      roomId: "",
      keywords: "",
      hotChatParam: {
        keywords: "",
        room_id: "",
        page: 0,
        perPage: 50,
        rendered: 0,
        totalRecords: 0
      },
      avatarArr: {
        room_title: "",
        room_photo: "@/assets/profiles/avatar-05.jpg"
      },
      chatContent: ""
      // activeId: ""
    };
    //  isactive : true
  },
  watch: {
    showPanel(val) {
      if(!val){
        this.recomendation = [];
      }
    },
    RefreshRoomChatData: {
      handler: function (val, oldVal) {
        if (val == true) {
          this.searchHandler();
          this.$store.dispatch("pusher/UpdateRefreshRoomChatData", false);
        }
      },
      deep: true
    },
    agentSession: {
      handler: function (val, oldVal) {
        if (
          oldVal &&
          oldVal.license_id &&
          val &&
          val.license_id &&
          oldVal.license_id !== val.license_id &&
          this.activeRoomId
        ) {
          this.$store.dispatch("pusher/NEW_UNREAD_MESSAGE_ROOM_UNSUB", {
            room_id: this.activeRoomId,
            license_id: oldVal.license_id,
            id: oldVal.id
          });
          this.$store.dispatch(
            "pusher/RefreshRoomChat_UNSUB",
            this.activeRoomId
          );
        }
        if (!val || typeof val.license_id == "undefined" || val.license_id == "") {
          this.$fire({
            title: "Error",
            text:
              "We cannot get your agent session, please login as agent for using this feature.",
            type: "error",
            timer: 3000
          }).then(async r => {
            this.$router.push("/index");
          });
        }
      },
      deep: true
    },
    NEW_UNREAD_MESSAGE_ROOM_Data: {
      handler: function (val, oldVal) {
        // console.log("oldVal", oldVal);
        // console.log("newVal", val);
        this.newMessageHandler(val);
      },
      deep: true
    },
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: {
      handler: function (val) {
        if (val && val.id && val.id === this.activeRoomId) {
          this.scheduleActiveRoomRefresh(val);
        }
      },
      deep: true
    },
    activeRoomId: {
      handler: function (val, oldVal) {
        if (val != "" && val != oldVal) {
          if (oldVal != "") {
            this.getMessageRoomUnsub(oldVal);
          }
          this.getNewUnreadMessageRoom(val);
        }
      },
      deep: true
    },
    hotChatListArr: {
      handler: function (val, oldVal) {
        if (val.length > 0 && val != oldVal) {
          this.buildMediaLightbox();
          this.buildMediaFile();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch("aiKey/getLanguageStyle");
    if (
      typeof this.agentSession.license_id == "undefined" ||
      this.agentSession.license_id == ""
    ) {
      console.log("agentsss", this.agentSession);
      this.$fire({
        title: "Error",
        text:
          "We cannot get your agent session, please login as an agent for using this feature.",
        type: "error",
        timer: 3000
      }).then(async r => {
        this.$router.push("/index");
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }

    // Dipasang setelah percakapan pertama tampil, karena .chat-wrap-inner
    // belum ada saat halaman dibuka tanpa percakapan aktif.
    this.$nextTick(() => this.bindChatHandlers());
  },
  updated() {
    // DOM chat dapat baru muncul setelah percakapan pertama dipilih.
    this.bindChatHandlers();
  },
  computed: {
    language_style() {
      return this.$store.state.aiKey.language_style;
    },
    ...mapGetters([
      "hotChatListArr",
      "activeRoomId",
      "textMessageArr",
      "agentSession",
      "activeProvider",
      "NEW_UNREAD_MESSAGE_ROOM_Data",
      "NEW_NUM_UNREAD_MESSAGE_ROOM_Data",
      "getRoomById",
      "getHotChatListArrById",
      "getHotChatListArrByDate",
      "roomListArr"
    ]),
    RefreshRoomChatData() {
      return this.$store.state.pusher.RefreshRoomChatData;
    },
    isActiveRoomReadyForSend() {
      return Boolean(
        this.activeRoomId &&
          this.activeRoomReady &&
          !this.loadingSwitchRoom &&
          this.roomDetail &&
          this.roomDetail.room_number
      );
    },
    canSendMessage() {
      return Boolean(this.textMessage && this.isActiveRoomReadyForSend);
    },
    chatTimezone() {
      const message = (this.hotChatListArr || []).find(row => {
        return row && row.tz;
      });
      const session = this.agentSession || {};
      const member = this.$store.state.login.memberSession || {};
      return (
        (message && message.tz) ||
        session.tz ||
        member.timezone ||
        ""
      );
    },
    groupChatByDate() {
      return groupMessagesByChatDate(
        this.hotChatListArr,
        new Date(this.chatDateNow),
        this.chatTimezone
      );
    },
    groupMessageMedia() {
      // return [];
      return this.$store.state.omniroom.groupMessageMedia;
    },
    groupMessageMediaFile() {
      // return [];
      return this.$store.state.omniroom.groupMessageMediaFile;
    },
    uploadMessageType() {
      return this.$store.state.omniwa.messageTypeCurrent;
    },
    messageTypeOptionsUpload() {
      return this.$store.state.omniwa.messageTypeOptionsUpload;
    },
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    objFilesMessageHandler() {
      return this.$store.state.omniwa.objFilesMessageHandler;
    },
    totalAttachmentSize() {
      return (this.files || []).reduce((total, file) => {
        return total + (Number(file.size) > 0 ? Number(file.size) : 0);
      }, 0);
    }
    // isUploadActive() {
    //   return typeof (this.$refs.upload != "undefined")
    //     ? this.$refs.upload.active
    //     : false;
    // },
    // isUploadCompleted() {
    //   // return this.$refs.upload.uploaded;
    //    return typeof (this.$refs.upload != "undefined")
    //     ? this.$refs.upload.uploaded
    //     : true;
    // }

    // newUUID: function() {
    //   const newID = uuid.v4();
    //   return newID;
    // }
  },
  async created() {

    this.$root.$on("switchRoom", async roomArr => {
      if (!roomArr || !roomArr.room_id) {
        return;
      }

      const switchToken = ++this.roomSwitchToken;
      this.loadingSwitchRoom = true;
      this.activeRoomReady = false;

      try {
        await this.emojiToggle(false);
        if (switchToken !== this.roomSwitchToken) {
          return;
        }
        this.isSearch = false;
        this.keywords = "";
        this.avatarArr.room_title = roomArr.room_title;
        this.avatarArr.room_photo = roomArr.room_photo;

        this.chatContent = "";
        // Jangan tampilkan pesan milik room sebelumnya selama riwayat
        // percakapan yang baru masih dimuat.
        await this.$store.dispatch("omniroom/setHotChatListArr", []);

        const initialRoom = this.$store.getters.getRoomById(roomArr.room_id);
        if (initialRoom) {
          this.roomDetail = initialRoom;
        }

        await this.getHotChatList(roomArr.room_id);
        if (switchToken !== this.roomSwitchToken) {
          return;
        }
        this.loadColdChats = true;

        const room = this.$store.getters.getRoomById(roomArr.room_id);
        this.roomDetail = room || {
          id: roomArr.room_id,
          room_title: roomArr.room_title || "",
          room_photo: roomArr.room_photo || "",
          provider: this.activeProvider,
          room_number: ""
        };
        this.activeRoomReady = Boolean(
          this.roomDetail && this.roomDetail.room_number
        );

        await this.cancelReplyMessage();
        if (switchToken !== this.roomSwitchToken) {
          return;
        }
        await this.scrollToBottom();
        await this.buildMediaLightbox();
        await this.buildMediaFile();
        this.isNotResolve(roomArr.room_id);
      } finally {
        if (switchToken === this.roomSwitchToken) {
          this.loadingSwitchRoom = false;
          this.$nextTick(() => {
            this.bindChatHandlers();
            // Setelah skeleton/loading dilepas, tinggi area chat berubah.
            // Posisikan kembali ke pesan terbaru agar separator tanggal
            // terakhir juga terlihat.
            this.scrollToBottom();
          });
        }
      }
    });

    this.$root.$on("contactUpdated", this.handleContactUpdated);

    this.$root.$on("openGallery", async message_media => {
      this.openGallery(message_media);
    });

    // Jaga label "Hari ini"/"Kemarin" tetap benar jika halaman terbuka
    // melewati pergantian hari.
    this._chatDateTimer = setInterval(() => {
      this.chatDateNow = Date.now();
    }, 60000);
    // console.log("hotChatList", this.hotChatListArr);
  },
  beforeDestroy() {
    if (this._chatDateTimer) {
      clearInterval(this._chatDateTimer);
    }
    this.$root.$off("switchRoom");
    this.$root.$off("contactUpdated", this.handleContactUpdated);
    this.$root.$off("openGallery");
    this.$root.$off("pollCheckIsOnline");
    if (this._activeRoomRefreshTimer) {
      clearTimeout(this._activeRoomRefreshTimer);
    }
    this.roomSwitchToken += 1;
    this.messageListRequestId += 1;
    this._messageListRequestInFlight = 0;
    this._pendingActiveRoomRefresh = "";
    this._activeRoomRefreshRunning = false;
    this.revokeAttachmentUrls();
    this.unbindChatHandlers();
    if (this.activeRoomId) {
      this.getMessageRoomUnsub(this.activeRoomId);
      this.$store.dispatch("pusher/RefreshRoomChat_UNSUB", this.activeRoomId);
    }
    this.$store.dispatch("omniroom/setIsShowDirectChats", false);
    this.$store.dispatch("omniroom/setIsShowBroadcast", false);
  },
  methods: { 
    toggleContactPanel() {
      this.showContactPanel = !this.showContactPanel;
      if (this.showContactPanel) {
        this.$root.$emit("aiSessionPanelOpened");
      }
    },
    handleContactUpdated(payload) {
      if (
        !payload ||
        !payload.roomId ||
        String(payload.roomId) !== String(this.activeRoomId)
      ) {
        return;
      }

      const roomTitle = payload.roomTitle || "";
      if (!roomTitle) {
        return;
      }

      this.avatarArr.room_title = roomTitle;
      if (this.roomDetail) {
        this.roomDetail.room_title = roomTitle;
      }
    },
    bindChatHandlers() {
      const listElm = document.querySelector(".chat-wrap-inner");
      if (!listElm || this._chatScrollEl === listElm) {
        return;
      }

      this.unbindChatHandlers();
      this._chatScrollEl = listElm;
      this._loadingOlderMessages = false;

      this._chatScrollHandler = async e => {
        if (e.target !== listElm) {
          return;
        }
        if (listElm.scrollTop === 0 && !this._loadingOlderMessages) {
          this._loadingOlderMessages = true;
          const previousHeight = listElm.scrollHeight;
          try {
            await this.infiniteHandler(
              this.currentState,
              this.hotChatParam.rendered,
              this.hotChatParam.totalRecords
            );
            await this.$nextTick();
            // Pertahankan konteks pesan yang sedang dibaca setelah pesan lama
            // ditambahkan di bagian atas.
            listElm.scrollTop =
              listElm.scrollHeight - previousHeight + listElm.scrollTop;
          } finally {
            this._loadingOlderMessages = false;
          }
        }
      };

      this._chatActionsHandler = e => {
        const targetName = e.target;
        if (!targetName || typeof targetName.className !== "string") {
          return;
        }
        const replyClass = targetName.className
          .split(" ")
          .find(name => name.indexOf("reply#") === 0);
        if (replyClass) {
          this.replyMessage(replyClass.split("#")[1]);
        }
      };

      listElm.addEventListener("scroll", this._chatScrollHandler);
      listElm.addEventListener("click", this._chatActionsHandler);
    },
    unbindChatHandlers() {
      if (this._chatScrollEl) {
        if (this._chatScrollHandler) {
          this._chatScrollEl.removeEventListener(
            "scroll",
            this._chatScrollHandler
          );
        }
        if (this._chatActionsHandler) {
          this._chatScrollEl.removeEventListener(
            "click",
            this._chatActionsHandler
          );
        }
      }
      this._chatScrollEl = null;
      this._chatScrollHandler = null;
      this._chatActionsHandler = null;
    },
    showFormatMenu() {
      const textarea = this.$refs.messagebox;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      if (start !== end) {
        // hitung posisi highlight (kira-kira di tengah highlight)
        const rect = textarea.getBoundingClientRect();
        const lineHeight = 20; // asumsi tinggi baris, bisa disesuaikan
        const top = rect.top + window.scrollY + textarea.offsetTop;
        const left = rect.left + window.scrollX + textarea.offsetLeft;

        this.menuPos = {
          x: left + 50, // geser horizontal (nanti bisa disesuaikan)
          y: top - lineHeight, // muncul di atas teks
        };

        this.selection = { start, end };
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
    applyFormat(symbol) {
      const { start, end } = this.selection;
      const text = this.textMessage;

      this.textMessage =
        text.slice(0, start) + symbol + text.slice(start, end) + symbol + text.slice(end);

      this.showMenu = false;

      // kembalikan fokus ke textarea
      this.$nextTick(() => {
        this.$refs.messagebox.focus();
        const selectStart = start 
        const selectEnd = end + symbol.length * 2;
        this.$refs.messagebox.setSelectionRange(selectStart, selectEnd);
        this.$refs.messagebox.focus();
      });
    },
    async revokeMessage(msgId, recipientNumber) {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          let param = {
            id: msgId,
            recipient_number: this.getWhatsappNumberFromJid(recipientNumber),
            agent_id: this.agentSession.id,
            room_id: this.activeRoomId
          }
          this.$store
            .dispatch("omniroom/revokeMessage", param)
            .then(() => {

            });
        }
      });
    },
    handleQuickReplyError(payload) {
      this.$fire({
        title: "Balasan Cepat",
        text:
          (payload && payload.message) ||
          "Template gagal dimuat. Silakan coba lagi.",
        type: "error",
        timer: 3000
      });
    },
    applyQuickReply(payload) {
      const text = payload && payload.text ? String(payload.text) : "";
      if (!text) {
        this.handleQuickReplyError({
          message: "Template ini tidak memiliki teks yang dapat dimasukkan."
        });
        return;
      }

      const textarea = this.$refs.messagebox;
      if (!textarea) {
        this.textMessage = this.textMessage
          ? this.textMessage + "\n" + text
          : text;
        return;
      }

      const start =
        typeof textarea.selectionStart === "number"
          ? textarea.selectionStart
          : this.textMessage.length;
      const end =
        typeof textarea.selectionEnd === "number"
          ? textarea.selectionEnd
          : start;
      const before = this.textMessage.slice(0, start);
      const after = this.textMessage.slice(end);
      const prefix = before && !/\s$/.test(before) ? "\n" : "";
      const suffix = after && !/^\s/.test(after) ? "\n" : "";
      this.textMessage = before + prefix + text + suffix + after;

      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = (before + prefix + text).length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
    },
    addTemplateToMesage(template) {
      // this.textMessage += template;
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // sisipkan emoji di posisi kursor
      this.textMessage =
        this.textMessage.substring(0, start) +
        template +
        this.textMessage.substring(end);

      // update posisi kursor setelah emoji
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + template.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
    },
    async setResolve() {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store
            .dispatch("omniroom/setResolve", this.activeRoomId)
            .then(() => {
              this.isNotResolveData = false;
              this.$store.dispatch("omniroom/setActiveRoomId", "");
              setTimeout(function () {
                location.reload();
              }, 3000);
            });
        }
      });
    },
    isNotResolve(roomId) {
      this.$store.dispatch("omniroom/isNotResolve", roomId).then(response => {
        this.isNotResolveData = response;
      });
    },
    updateMessageTypeCurrent(msgType) {
      this.$store.dispatch("omniwa/messageTypeCurrent", msgType);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
    async onlyUploadFile() {
      var formData = await new FormData();
      await formData.append("files", this.files[0].file);
      await formData.append("message_type", "image");
      // return this.storeResource(formData);
      // var postData = {};
      // postData = { files: this.files[0].file, message_type: "image" };
      // console.log("postdata", postData);
      await this.$store
        .dispatch("omniwa/onlyUploadFile", formData)
        .then(response => {
          console.log("respp", response);
          return Promise.resolve(response);
        })
        .catch(err => {
          // console.log("errrr", err.response);
          return Promise.reject(err.response.data.msg);
        });
      // return await component.uploadHtml4(this.files[0].file);
    },
    getFileExtension(name) {
      const value = String(name || "");
      const dot = value.lastIndexOf(".");
      if (dot === -1 || dot === value.length - 1) {
        return "";
      }
      return value.slice(dot + 1).toLowerCase();
    },
    getFileCategory(file) {
      const source = file && file.file ? file.file : file;
      const name = source && source.name ? source.name : "";
      const ext = this.getFileExtension(name);
      if (this.supportedImageExtensions.indexOf(ext) !== -1) {
        return "image";
      }
      if (this.supportedVideoExtensions.indexOf(ext) !== -1) {
        return "video";
      }
      if (this.supportedDocumentExtensions.indexOf(ext) !== -1) {
        return "document";
      }
      return "";
    },
    getMimeCategory(file) {
      const source = file && file.file ? file.file : file;
      const mime = String((source && source.type) || "").toLowerCase();
      if (!mime || mime === "application/octet-stream") {
        return "";
      }
      if (mime.indexOf("image/") === 0) {
        return "image";
      }
      if (mime.indexOf("video/") === 0) {
        return "video";
      }
      if (
        mime === "application/pdf" ||
        mime === "application/zip" ||
        mime === "application/x-zip-compressed" ||
        mime.indexOf("msword") !== -1 ||
        mime.indexOf("ms-excel") !== -1 ||
        mime.indexOf("officedocument") !== -1
      ) {
        return "document";
      }
      return "";
    },
    isCategoryAllowedForMessageType(category, messageType) {
      if (messageType === "image") {
        return category === "image";
      }
      if (messageType === "video") {
        return category === "video";
      }
      return !!category;
    },
    inferUploadMessageType(files) {
      const categories = (files || [])
        .map(file => this.getFileCategory(file))
        .filter(category => !!category);
      if (categories.length === 0) {
        return this.uploadMessageType;
      }
      if (categories.every(category => category === "image")) {
        return "image";
      }
      if (categories.every(category => category === "video")) {
        return "video";
      }
      return "document";
    },
    getAttachmentFingerprint(file) {
      const source = file && file.file ? file.file : file;
      return [
        source.name || "",
        Number(source.size) || 0,
        source.type || ""
      ].join("::");
    },
    isDuplicateAttachment(file, list) {
      const fingerprint = this.getAttachmentFingerprint(file);
      return (list || []).some(existing => {
        return this.getAttachmentFingerprint(existing) === fingerprint;
      });
    },
    getAttachmentErrorMessage(error) {
      const message =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.msg) ||
        (error && error.message) ||
        "";
      if (/Only support message type/i.test(message)) {
        return "Jenis media ini belum didukung oleh server. Silakan gunakan gambar atau dokumen.";
      }
      if (/Only allowed file/i.test(message)) {
        return "Format berkas tidak didukung oleh server.";
      }
      return message || "Berkas gagal dikirim. Silakan coba lagi.";
    },
    validateAttachmentFile(file, messageType, currentFiles) {
      const source = file && file.file ? file.file : file;
      const name = (source && source.name) || "berkas";
      const category = this.getFileCategory(file);
      const current = currentFiles || [];

      if (!category) {
        return "Format " + name + " tidak didukung. Gunakan format yang tertera.";
      }
      const mimeCategory = this.getMimeCategory(file);
      if (mimeCategory && mimeCategory !== category) {
        return "Tipe MIME " + name + " tidak sesuai dengan ekstensinya.";
      }
      if (!this.isCategoryAllowedForMessageType(category, messageType)) {
        return (
          "Berkas " +
          name +
          " tidak sesuai dengan jenis pesan " +
          messageType +
          "."
        );
      }

      const fileSize = Number(file && file.size) || Number(source && source.size) || 0;
      if (fileSize <= 0) {
        return "Berkas " + name + " kosong atau tidak dapat dibaca.";
      }
      if (fileSize > this.maxUploadSize) {
        return "Ukuran " + name + " melebihi batas 10 MB.";
      }
      const currentSize = current.reduce((total, item) => {
        return total + (Number(item.size) || 0);
      }, 0);
      if (currentSize + fileSize > this.maxUploadSize) {
        return "Total ukuran berkas melebihi batas 10 MB.";
      }
      if (current.length >= this.maximumUpload) {
        return "Maksimal " + this.maximumUpload + " berkas dalam satu pengiriman.";
      }
      if (this.isDuplicateAttachment(file, current)) {
        return "Berkas " + name + " sudah dipilih.";
      }
      return "";
    },
    notifyAttachmentError(message) {
      this.$fire({
        title: "Lampiran",
        text: message,
        type: "error",
        timer: 4000
      });
    },
    ensureAttachmentModal() {
      const modal = document.getElementById("drag_files");
      if (!modal || modal.classList.contains("show")) {
        return;
      }
      const button = document.getElementById("btnDragFiles");
      if (button) {
        button.click();
      }
    },
    handleAttachmentFileInput(event) {
      const input = event && event.target;
      const files = input && input.files ? input.files : [];
      this.addAttachmentFiles(files, "picker");
      // Reset agar berkas yang sama dapat dipilih kembali setelah dihapus.
      if (input) {
        input.value = "";
      }
    },
    handleAttachmentDragLeave(event) {
      const current = event && event.currentTarget;
      const related = event && event.relatedTarget;
      if (!current || !related || !current.contains(related)) {
        this.isDraggingFiles = false;
      }
    },
    handleAttachmentDrop(event) {
      this.isDraggingFiles = false;
      const transfer = event && event.dataTransfer;
      if (!transfer) {
        return;
      }
      const files = [];
      if (transfer.files) {
        for (let i = 0; i < transfer.files.length; i++) {
          files.push(transfer.files[i]);
        }
      }
      if (files.length > 0) {
        event.preventDefault();
        this.addAttachmentFiles(files, "drop");
      }
    },
    getClipboardFiles(clipboardData) {
      if (!clipboardData) {
        return [];
      }
      const files = [];
      if (clipboardData.items) {
        for (let i = 0; i < clipboardData.items.length; i++) {
          const item = clipboardData.items[i];
          if (item && item.kind === "file") {
            const file = item.getAsFile && item.getAsFile();
            if (file) {
              files.push(file);
            }
          }
        }
      }
      if (files.length === 0 && clipboardData.files) {
        for (let i = 0; i < clipboardData.files.length; i++) {
          files.push(clipboardData.files[i]);
        }
      }
      return files;
    },
    handleComposerPaste(event) {
      const files = this.getClipboardFiles(event && event.clipboardData);
      if (!files.length) {
        return;
      }
      const clipboardText = event.clipboardData &&
        event.clipboardData.getData
        ? event.clipboardData.getData("text/plain")
        : "";
      // Teks biasa tetap dipaste oleh browser. preventDefault hanya dipakai
      // ketika clipboard tidak membawa teks yang perlu dipertahankan.
      if (!clipboardText) {
        event.preventDefault();
      }
      this.addAttachmentFiles(files, "paste");
    },
    handleComposerDragEnter(event) {
      const transfer = event && event.dataTransfer;
      const types = transfer && transfer.types;
      if (!types || Array.prototype.indexOf.call(types, "Files") !== -1) {
        this.isDraggingFiles = true;
      }
    },
    handleComposerDragOver(event) {
      if (event && event.dataTransfer && event.dataTransfer.types) {
        this.isDraggingFiles = true;
      }
    },
    handleComposerDragLeave(event) {
      const current = event && event.currentTarget;
      const related = event && event.relatedTarget;
      if (!current || !related || !current.contains(related)) {
        this.isDraggingFiles = false;
      }
    },
    handleComposerDrop(event) {
      this.isDraggingFiles = false;
      const transfer = event && event.dataTransfer;
      if (!transfer) {
        return;
      }
      const files = [];
      if (transfer.files) {
        for (let i = 0; i < transfer.files.length; i++) {
          files.push(transfer.files[i]);
        }
      }
      if (files.length === 0 && transfer.items) {
        for (let i = 0; i < transfer.items.length; i++) {
          const item = transfer.items[i];
          if (item && item.kind === "file") {
            const file = item.getAsFile && item.getAsFile();
            if (file) {
              files.push(file);
            }
          }
        }
      }
      if (files.length > 0) {
        event.preventDefault();
        this.addAttachmentFiles(files, "drop");
      }
    },
    addAttachmentFiles(files, source) {
      const candidates = Array.from(files || []).filter(file => !!file);
      if (candidates.length === 0) {
        return;
      }
      if (this.activeRoomId === "") {
        this.notifyAttachmentError(
          "Pilih percakapan terlebih dahulu sebelum melampirkan berkas."
        );
        return;
      }

      this.ensureAttachmentModal();

      let messageType = this.uploadMessageType;
      if (this.files.length === 0) {
        messageType = this.inferUploadMessageType(candidates);
      } else if (messageType !== "document") {
        const existingCategory = this.files
          .map(file => this.getFileCategory(file))
          .filter(category => !!category)[0];
        const hasDifferentCategory = candidates.some(file => {
          const category = this.getFileCategory(file);
          return category && existingCategory && category !== existingCategory;
        });
        if (hasDifferentCategory) {
          messageType = "document";
        }
      }
      if (messageType !== this.uploadMessageType) {
        this.updateMessageTypeCurrent(messageType);
      }

      const accepted = [];
      const errors = [];
      candidates.forEach(file => {
        const error = this.validateAttachmentFile(
          file,
          messageType,
          this.files.concat(accepted)
        );
        if (error) {
          errors.push(error);
        } else {
          accepted.push(file);
        }
      });

      if (accepted.length > 0) {
        const newAttachments = accepted.map(file => {
          const URL = window.URL || window.webkitURL;
          let blob = "";
          try {
            blob = URL.createObjectURL(file);
          } catch (error) {
            blob = "";
          }
          return {
            id: uuid.v4(),
            file: file,
            name: file.name,
            size: file.size,
            type: file.type,
            blob: blob,
            thumb: this.getFileCategory(file) === "image" ? blob : "",
            error: "",
            edited: false,
            success: false,
            sending: false,
            progress: "0.00",
            active: false
          };
        });
        this.files = this.files.concat(newAttachments);
      }
      if (errors.length > 0) {
        this.notifyAttachmentError(
          errors.length === 1
            ? errors[0]
            : errors[0] + " " + (errors.length - 1) + " berkas lainnya ditolak."
        );
      }
    },
    revokeAttachmentUrl(file) {
      if (file && file.blob) {
        try {
          (window.URL || window.webkitURL).revokeObjectURL(file.blob);
        } catch (error) {
          // Object URL mungkin sudah dilepas.
        }
      }
    },
    removeAttachment(file) {
      if (!file || file.sending) {
        return;
      }
      const index = (this.files || []).indexOf(file);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
      this.revokeAttachmentUrl(file);
    },
    clearAttachments() {
      (this.files || []).forEach(file => this.revokeAttachmentUrl(file));
      this.files = [];
      this.thumbUpload = [];
    },
    revokeAttachmentUrls() {
      (this.files || []).forEach(file => this.revokeAttachmentUrl(file));
    },
    isImageAttachment(file) {
      return this.getFileCategory(file) === "image";
    },
    isVideoAttachment(file) {
      return this.getFileCategory(file) === "video";
    },
    isGifAttachment(file) {
      const source = file && file.file ? file.file : file;
      return this.getFileExtension(source && source.name) === "gif";
    },
    canEditImageAttachment(file) {
      return this.isImageAttachment(file) && !this.isGifAttachment(file);
    },
    getImageEditorTitle(file) {
      if (this.isGifAttachment(file)) {
        return "GIF animasi tidak dapat diedit tanpa kehilangan animasi.";
      }
      return "Edit gambar sebelum dikirim";
    },
    openImageEditor(file) {
      if (!file || !this.isImageAttachment(file)) {
        return;
      }
      if (this.isGifAttachment(file)) {
        this.notifyAttachmentError(
          "GIF animasi tidak dapat diedit tanpa kehilangan animasinya. File asli akan dipertahankan."
        );
        return;
      }
      if (!file.file) {
        this.notifyAttachmentError("Berkas gambar tidak dapat dibuka.");
        return;
      }
      this.imageEditorAttachmentId = file.id;
      this.imageEditorFile = file.file;
      this.imageEditorName = file.name;
      this.imageEditorOpen = true;
    },
    closeImageEditor() {
      this.imageEditorOpen = false;
      this.imageEditorFile = null;
      this.imageEditorName = "";
      this.imageEditorAttachmentId = null;
    },
    applyEditedImage(editedFile) {
      const attachment = (this.files || []).find(
        file => file.id === this.imageEditorAttachmentId
      );
      if (!attachment || !editedFile) {
        this.closeImageEditor();
        return;
      }
      if (!editedFile.size) {
        this.notifyAttachmentError(
          "Gambar hasil edit kosong atau tidak dapat dibaca."
        );
        return;
      }

      const otherSize = (this.files || []).reduce((total, file) => {
        return file.id === attachment.id ? total : total + (Number(file.size) || 0);
      }, 0);
      if (otherSize + editedFile.size > this.maxUploadSize) {
        this.notifyAttachmentError(
          "Gambar hasil edit membuat total lampiran melebihi batas 10 MB."
        );
        return;
      }

      const oldBlob = attachment.blob;
      const URL = window.URL || window.webkitURL;
      let blobUrl = "";
      try {
        blobUrl = URL.createObjectURL(editedFile);
      } catch (error) {
        this.notifyAttachmentError("Gagal membuat preview gambar hasil edit.");
        return;
      }

      attachment.file = editedFile;
      attachment.name = editedFile.name;
      attachment.size = editedFile.size;
      attachment.type = editedFile.type;
      attachment.blob = blobUrl;
      attachment.thumb = blobUrl;
      attachment.error = "";
      this.$set(attachment, "edited", true);

      if (oldBlob) {
        this.revokeAttachmentUrl({ blob: oldBlob });
      }
      this.closeImageEditor();
    },
    getAttachmentLabel(file) {
      const category = this.getFileCategory(file);
      const labels = {
        image: "Gambar",
        video: "Video",
        document: "Dokumen"
      };
      return labels[category] || "Berkas";
    },
    getAttachmentIcon(file) {
      const source = file && file.file ? file.file : file;
      const ext = this.getFileExtension(source && source.name);
      if (ext === "pdf") return "fa fa-file-pdf-o";
      if (["xls", "xlsx", "csv"].indexOf(ext) !== -1) return "fa fa-file-excel-o";
      if (["doc", "docx"].indexOf(ext) !== -1) return "fa fa-file-word-o";
      if (["zip", "rar", "7z"].indexOf(ext) !== -1) return "fa fa-file-archive-o";
      if (this.supportedVideoExtensions.indexOf(ext) !== -1) return "fa fa-film";
      if (this.supportedImageExtensions.indexOf(ext) !== -1) return "fa fa-picture-o";
      return "fa fa-file-o";
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    async openGallery(messageUrl) {
      var index = await this.getIndexImage(messageUrl);
      // console.log("indexxx", messageUrl, index);
      // if(index)
      await this.$refs.lightbox.showImage(index);
    },
    buildMediaLightbox() {
      var data = [];
      this.hotChatListArr.forEach((rowArr, index) => {
        var row = {};
        if (rowArr.message_type == "image") {
          row = {
            from_me: rowArr.from_me,
            media_size: rowArr.media_size,
            message_type: rowArr.message_type,
            message_name: rowArr.message_name,
            message_media: rowArr.message_media,
            timeISODatetime: rowArr.timeISODatetime,
            thumb: rowArr.message_media,
            src: rowArr.message_media,
            caption: rowArr.message // Optional
          };
          data.push(row);
        }
      });
      this.$store.dispatch("omniroom/setGroupMessageMedia", data);
      // return data;
    },
    buildMediaFile() {
      var data = [];
      this.hotChatListArr.forEach((rowArr, index) => {
        var row = {};
        if (
          rowArr.message_type == "document" ||
          rowArr.message_type == "video" ||
          rowArr.message_type == "file"
        ) {
          row = {
            from_me: rowArr.from_me,
            media_size: rowArr.media_size,
            message_type: rowArr.message_type,
            message_name: rowArr.message_name,
            message_media: rowArr.message_media,
            timeISODatetime: rowArr.timeISODatetime,
            thumb: rowArr.message_media,
            src: rowArr.message_media,
            caption: rowArr.message // Optional
          };
          data.push(row);
        }
      });
      this.$store.dispatch("omniroom/setGroupMessageMediaFile", data);
      // return data;
    },
    getIndexImage(messageUrl) {
      var index = this.groupMessageMedia
        .map(x => {
          return x.src;
        })
        .indexOf(messageUrl);
      return index;
    },
    messageFilter(message) {
      if (!message) return "";
      return String(message)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\r?\n/g, "<br />")
        .replace(/```([^`]+)```/g, "<pre>$1</pre>")
        .replace(/\*(.*?)\*/g, "<b>$1</b>")
        .replace(/_(.*?)_/g, "<i>$1</i>")
        .replace(/~(.*?)~/g, "<s>$1</s>");
    },
    messageFilterOld(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    cancelReplyMessage(force = false) {
      // console.log("this.isReplyMessage", this.isReplyMessage);
      // console.log("this.roomDetail.room_number", this.roomDetail);

      if (force == true) {
        this.isReplyTo = false;
        return;
      }

      if (
        this.isReplyMessage != null &&
        typeof this.isReplyMessage.message_number != "undefined"
      ) {
        if (this.roomDetail.room_number == "") {
          this.isReplyTo = false;
        }
        if (this.isReplyMessage.message_number != this.roomDetail.room_number) {
          this.isReplyTo = false;
        }
      }
    },
    replyMessage(msgListId) {
      // alert("xxx");
      if (typeof msgListId != "undefined" && msgListId != "") {
        this.isReplyTo = true;
        this.isReplyMessage = this.$store.getters.getHotChatListArrById(
          msgListId
        );
        // console.log("msgArr", this.isReplyMessage);
      }
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    getAgentSession() {
      return getAgentSession();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "82%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      const textarea = this.$refs.messagebox; // pastikan textarea punya ref="messagebox"
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // sisipkan emoji di posisi kursor
      this.textMessage =
        this.textMessage.substring(0, start) +
        args.emoji +
        this.textMessage.substring(end);

      // update posisi kursor setelah emoji
      this.$nextTick(() => {
        textarea.focus();
        const cursorPos = start + args.emoji.length;
        textarea.setSelectionRange(cursorPos, cursorPos);
      });
    },
    selectedEmojiOld(args) {
      this.textMessage += args.emoji;
      // console.log(args); /* return {...}*/
    },
    async getMessageRoomUnsub(roomId) {
      console.log("before if::", "getMessageRoomUnsub");

      if (roomId != "") {
        console.log("action::", "getNewUnreadMessageRoom");
        let paramArr = await {
          room_id: roomId,
          license_id: this.agentSession.license_id,
          id: this.agentSession.id
        };
        await this.$store.dispatch(
          "pusher/NEW_UNREAD_MESSAGE_ROOM_UNSUB",
          paramArr
        );
      }
    },
    async getNewUnreadMessageRoom(roomId) {
      // console.log("before if::", "getNewUnreadMessageRoom");

      if (roomId != "") {
        // console.log("after if::", "getNewUnreadMessageRoom");
        let paramArr = await {
          room_id: roomId,
          license_id: this.agentSession.license_id,
          id: this.agentSession.id
        };
        // console.log(paramArr);
        await this.$store.dispatch("pusher/NEW_UNREAD_MESSAGE_ROOM", paramArr);
      }
    },
    updateActiveRoomFromRealtime(rows) {
      if (!this.activeRoomId || !rows || rows.length === 0) {
        return;
      }
      const last = rows[rows.length - 1];
      if (!last || (last.room_id && last.room_id !== this.activeRoomId)) {
        return;
      }

      const index = (this.roomListArr || []).findIndex(room => {
        return room.id === this.activeRoomId;
      });
      if (index < 0) {
        return;
      }

      const room = this.roomListArr[index];
      const updated = Object.assign({}, room, {
        room_last_chat_name: last.message_name || room.room_last_chat_name,
        room_last_chat_message: last.message || room.room_last_chat_message,
        update_datetime: last.create_datetime || room.update_datetime
      });
      const list = (this.roomListArr || []).slice();
      list.splice(index, 1, updated);
      this.$store.dispatch("omniroom/setRoomListArr", list);
    },
    scheduleActiveRoomRefresh(room) {
      const targetMessageId = room && room.room_last_chat_message_id;
      if (!targetMessageId) {
        return;
      }
      const hasMessage = this.hotChatListArr.some(row => {
        return row.message_id === targetMessageId || row.id === targetMessageId;
      });
      if (hasMessage) {
        return;
      }

      if (this._activeRoomRefreshTimer) {
        clearTimeout(this._activeRoomRefreshTimer);
      }
      const roomId = this.activeRoomId;
      this._activeRoomRefreshTimer = setTimeout(async () => {
        if (roomId !== this.activeRoomId) {
          return;
        }
        const stillMissing = !this.hotChatListArr.some(row => {
          return (
            row.message_id === targetMessageId ||
            row.id === targetMessageId
          );
        });
        if (!stillMissing) {
          return;
        }

        const listElm = document.querySelector(".chat-wrap-inner");
        const previousScrollTop = listElm ? listElm.scrollTop : 0;
        const wasAtBottom =
          !listElm ||
          listElm.scrollHeight - listElm.scrollTop - listElm.clientHeight < 80;
        await this.getHotChatList(roomId);
        await this.buildMediaLightbox();
        await this.buildMediaFile();
        if (wasAtBottom) {
          await this.scrollToBottom();
        } else if (listElm) {
          await this.$nextTick();
          listElm.scrollTop = previousScrollTop;
        }
      }, 350);
    },
    async newMessageHandler(messageArr) {
      const incoming = Array.isArray(messageArr)
        ? messageArr
        : messageArr
        ? [messageArr]
        : [];
      if (incoming.length === 0) {
        return;
      }

      const roomId = this.activeRoomId;
      if (!roomId) {
        return;
      }
      const rows = incoming
        .filter(row => {
          return !row.room_id || row.room_id === roomId;
        })
        .map(row => {
          const messageDate = getMessageDate(row);
          return Object.assign({}, row, {
            timeISODate:
              row.timeISODate ||
              (messageDate
                ? formatDateForMessage(messageDate, "ISODate")
                : ""),
            timeMinuteHour:
              row.timeMinuteHour ||
              (messageDate
                ? formatDateForMessage(messageDate, "MinuteHour")
                : ""),
            timeISODatetime:
              row.timeISODatetime ||
              (messageDate
                ? formatDateForMessage(messageDate, "ISODatetime")
                : "")
          });
        });
      if (rows.length === 0) {
        return;
      }
      // Event bisa datang terlambat setelah user berpindah percakapan.
      if (this.activeRoomId !== roomId) {
        return;
      }

      const listElm = document.querySelector(".chat-wrap-inner");
      const previousScrollTop = listElm ? listElm.scrollTop : 0;
      const wasAtBottom =
        !listElm ||
        listElm.scrollHeight - listElm.scrollTop - listElm.clientHeight < 80;

      rows.forEach(row => {
        const rowMessageId = row.message_id;
        const hasDedupeId =
          rowMessageId && rowMessageId !== "-" && rowMessageId !== "0";
        const index = this.hotChatListArr.findIndex(item => {
          return (
            (row.id && item.id === row.id) ||
            (hasDedupeId && item.message_id === rowMessageId)
          );
        });
        if (index >= 0) {
          this.hotChatListArr.splice(index, 1);
        }
        this.hotChatListArr.push(row);
      });

      // Bila riwayat masih dimuat, respons lama berpotensi menimpa pesan
      // realtime yang baru saja ditambahkan. Batalkan request tersebut lalu
      // muat ulang daftar pesan dari server.
      if (this._messageListRequestInFlight > 0) {
        this.messageListRequestId += 1;
        this.refreshActiveRoomMessages(this.activeRoomId);
      }

      this.chatContent = "";
      await this.generateMessage(this.activeRoomId);
      await this.buildMediaLightbox();
      await this.buildMediaFile();
      this.updateActiveRoomFromRealtime(rows);

      if (wasAtBottom) {
        await this.scrollToBottom();
      } else if (listElm) {
        await this.$nextTick();
        listElm.scrollTop = previousScrollTop;
      }
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
  

    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.textMessageHandler();
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        if (this.files && this.files.length) {
          this.filesMessageHandler();
        }
      }
    },
    formatDateForMessage(dateIso, type) {
      return formatDateForMessage(dateIso, type);
    },
    filesMessageHandler() {
      if (!this.isActiveRoomReadyForSend) {
        this.notifyAttachmentError(
          this.activeRoomId
            ? "Percakapan masih dimuat. Tunggu hingga riwayat selesai dimuat."
            : "Pilih percakapan terlebih dahulu sebelum mengirim lampiran."
        );
        return;
      }
      if (!this.files || this.files.length === 0) {
        return;
      }

      const messageType = this.uploadMessageType;
      const validationErrors = [];
      const accepted = [];
      this.files.forEach(file => {
        const error = this.validateAttachmentFile(
          file,
          messageType,
          accepted
        );
        if (error) {
          file.error = error;
          validationErrors.push(error);
        } else {
          file.error = "";
          accepted.push(file);
        }
      });
      if (validationErrors.length > 0) {
        this.notifyAttachmentError(
          validationErrors.length === 1
            ? validationErrors[0]
            : validationErrors[0] +
              " " +
              (validationErrors.length - 1) +
              " berkas lainnya tidak valid."
        );
        return;
      }

      const caption = String(this.caption || "").trim();
      const recipientNumber = this.getWhatsappNumberFromJid(
        this.roomDetail.room_number
      );
      const quotedId =
        this.isReplyTo == true ? this.isReplyMessage.message_id : "";
      const quotedMessage =
        this.isReplyTo == true ? this.isReplyMessage.message : "";
      const roomNumber = this.roomDetail.room_number;
      const sentRoomId = this.activeRoomId;
      const attachments = this.files
        .filter(file => file && file.file && !file.success)
        .map(file => ({
          file: file.file,
          name: file.name || file.file.name || "berkas"
        }));

      if (attachments.length === 0) {
        return;
      }

      const requests = attachments.map(row => {
        const formData = new FormData();
        formData.append("file", row.file);
        formData.append("message_type", messageType);
        formData.append("id", uuid.v4());
        formData.append("text", caption);
        formData.append("recipient_number", recipientNumber);
        formData.append("quoted_id", quotedId);
        formData.append("quoted_message", quotedMessage);
        return { formData: formData, name: row.name };
      });

      // Snapshot request sudah lengkap. Bersihkan hanya state milik batch ini;
      // request lama tidak boleh menyentuh attachment/caption baru.
      this.caption = "";
      this.thumbUpload = [];
      this.clearAttachments();
      this.cancelReplyMessage(true);
      const modalCloseButton = document.getElementById("btnCloseUploadFiles");
      if (modalCloseButton) {
        modalCloseButton.click();
      }
      this.$fire({
        title: "Berhasil",
        text: "Lampiran sedang dikirim.",
        type: "success",
        timer: 2000
      });

      requests.forEach(request => {
        this.$store
          .dispatch("omniwa/sendFile", request.formData)
          .then(response => {
            this.removeNewRoomAfterSend(roomNumber);
            if (this.shouldRefreshAfterSend(sentRoomId, response)) {
              this.refreshActiveRoomMessages(sentRoomId);
            }
            this.$root.$emit("aiSessionRefreshRequested", {
              roomId: sentRoomId,
              roomNumber: roomNumber
            });
          })
          .catch(error => {
            this.notifyAttachmentError(
              request.name + ": " + this.getAttachmentErrorMessage(error)
            );
            this.removeNewRoomAfterSend(roomNumber);
          });
      });
    },
    notifySendError(error) {
      const message =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.msg) ||
        (error && error.message) ||
        "Pesan gagal dikirim. Silakan coba lagi.";
      this.$fire({
        title: "Kirim Pesan",
        text: message,
        type: "error",
        timer: 4000
      });
    },
    textMessageHandler() {
      if (!this.textMessage) {
        return;
      }
      if (!this.isActiveRoomReadyForSend) {
        this.$fire({
          title: "Kirim Pesan",
          text:
            "Percakapan masih dimuat. Tunggu hingga riwayat selesai dimuat sebelum mengirim pesan.",
          type: "warning",
          timer: 2500
        });
        return;
      }

      const sentRoomId = this.activeRoomId;
      const sentRoomNumber = this.roomDetail.room_number;
      let messageText = "";
      try {
        messageText = this.remove_tags(this.textMessage);
      } catch (error) {
        this.notifySendError(error);
        return;
      }
      if (!messageText) {
        return;
      }

      const agentName =
        this.agentSession.is_owner == 1
          ? ""
          : "\n\n~" + this.agentSession.first_name;
      const quotedId =
        this.isReplyTo == true ? this.isReplyMessage.message_id : "";
      const quotedMessage =
        this.isReplyTo == true ? this.isReplyMessage.message : "";
      const dataArr = {
        recipient_number: this.getWhatsappNumberFromJid(
          this.roomDetail.room_number
        ),
        id: uuid.v4(),
        text: messageText + agentName,
        quoted_id: quotedId,
        quoted_message: quotedMessage
      };

      // Snapshot sudah dibuat. Kosongkan composer secara sinkron agar request
      // berikutnya tidak menunggu respons dan tidak menimpa pesan baru.
      this.emojiToggle(false);
      this.textMessage = "";
      this.cancelReplyMessage(true);

      this.$store
        .dispatch("omniwa/sendText", dataArr)
        .then(response => {
          this.removeNewRoomAfterSend(sentRoomNumber);
          if (this.shouldRefreshAfterSend(sentRoomId, response)) {
            this.refreshActiveRoomMessages(sentRoomId);
          }
          this.$root.$emit("aiSessionRefreshRequested", {
            roomId: sentRoomId,
            roomNumber: sentRoomNumber
          });
        })
        .catch(error => {
          this.notifySendError(error);
          this.removeNewRoomAfterSend(sentRoomNumber);
        });
    },

    async changeRoomListArr(data) {
      // console.log("changeHotChatListArr::", data);
      var newArr = this.getUniqueListBy(data, "id");
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      this.$store.dispatch("omniroom/setRoomListArr", newArr);
    },
    async removeNewRoomAfterSend(roomNumber) {
      if (this.activeRoomId !== "new-room") {
        return;
      }

      // Jangan reload halaman. Minta sidebar mencari room kanonis dari API;
      // bila event Pusher datang lebih dulu, merge di sidebar yang akan
      // menggantikan room sementara ini.
      this.$root.$emit("refreshRoomForContact", {
        room_number: roomNumber || this.roomDetail.room_number,
        license_id: this.agentSession.license_id
      });
    },
    async searchHandler() {
      if (this.activeRoomId != "") {
        this.chatContent = await "";
        await this.getHotChatList(this.activeRoomId);
        this.loading = await false;
      }
    },
    formatDate(dateIso) {
      return formatDate(dateIso);
    },
    async changeHotChatListArr(data) {
      // console.log("changeHotChatListArr::", data);
      var newArr = await this.getUniqueListBy(data, "id");

      // console.log("builllll", buildArr);
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      await this.$store.dispatch("omniroom/setHotChatListArr", newArr);
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },

    async infiniteHandler($state, numLoaded, totalData, init = false) {
      // console.log("this.activeRoomId::", this.activeRoomId);
      if (init == true) {
        await this.getColdChatList(this.activeRoomId);
      }
      console.log("numLoaded:", numLoaded, totalData);

      // if (numLoaded <= totalData && totalData > 0 && numLoaded > 0) {
      if (numLoaded < totalData && totalData > 0 && numLoaded > 0) {
        if (this.activeRoomId != "") {
          await $state.loaded();
          // this.loading = await true; //dimatikan
          // await $state.loaded();
          if (init == false) {
            await this.getColdChatList(this.activeRoomId);
          }
        }
        // console.log("loaded", numLoaded, totalData);
      } else {
        // console.log("complete", numLoaded, totalData);
        // console.log(
        //   "complete",
        //   this.hotChatParam.totalRecords,
        //   this.hotChatParam.rendered
        // );

        await $state.complete();
        // Saat load awal, posisi akhir ditentukan oleh scrollToBottom milik
        // pemilihan room. Jangan paksa kembali ke atas setelah separator
        // tanggal ikut dirender.
        if (!init && numLoaded >= totalData && numLoaded > 0) {
          const listElm = document.querySelector(".chat-wrap-inner");
          if (listElm) {
            listElm.scrollTop = 1;
          }
        }

        if (numLoaded == totalData && totalData > 0) {
          this.chatContent = await "";
          await this.generateMessage(this.activeRoomId);
        }
        // this.loading = await false;

        // console.log("complete", numLoaded, totalData);
      }
      this.currentState = await $state;
    },
    async generateMessage(roomId) {
      this.loading = await true;

      var checkDate = "";
      this.loading = await false;
    },
    lazyHandler(component) {
      console.log("this component is showing");
    },
    async fetchHotChatList(roomId) {
      const requestId = ++this.messageListRequestId;
      const requestParams = Object.assign({}, this.hotChatParam, {
        room_id: roomId,
        keywords: this.keywords,
        page: 0,
        rendered: 0,
        totalRecords: 0
      });

      this._messageListRequestInFlight =
        (this._messageListRequestInFlight || 0) + 1;
      try {
        const response = await this.$store.dispatch(
          "omniroom/getHotChatList",
          requestParams
        );
        if (
          requestId !== this.messageListRequestId ||
          this.activeRoomId !== roomId
        ) {
          return null;
        }

        if (!Array.isArray(response)) {
          return null;
        }

        const rows = response;
        await this.changeHotChatListArr(rows);
        this.hotChatParam.room_id = roomId;
        this.hotChatParam.keywords = this.keywords;
        this.hotChatParam.totalRecords = rows.length;
        return rows;
      } catch (error) {
        if (requestId === this.messageListRequestId) {
          console.log("error", error);
        }
        return null;
      } finally {
        this._messageListRequestInFlight = Math.max(
          0,
          (this._messageListRequestInFlight || 1) - 1
        );
      }
    },
    async getHotChatList(roomId) {
      this.loading = true;
      this.hotChatParam.totalRecords = 0;

      const rows = await this.fetchHotChatList(roomId);
      if (rows === null || this.activeRoomId !== roomId) {
        this.loading = false;
        return;
      }

      this.hotChatParam.page = 0;
      this.hotChatParam.rendered = 0;
      await this.infiniteHandler(this.currentState, 1, rows.length, true);
      this.loading = false;
    },
    async reloadActiveRoomMessages(roomId) {
      if (!roomId || this.activeRoomId !== roomId) {
        return false;
      }

      const listElm = document.querySelector(".chat-wrap-inner");
      const previousScrollTop = listElm ? listElm.scrollTop : 0;
      const wasAtBottom =
        !listElm ||
        listElm.scrollHeight - listElm.scrollTop - listElm.clientHeight < 80;

      const rows = await this.fetchHotChatList(roomId);
      if (rows === null || this.activeRoomId !== roomId) {
        return false;
      }

      await this.buildMediaLightbox();
      await this.buildMediaFile();
      if (wasAtBottom) {
        await this.scrollToBottom();
      } else if (listElm) {
        await this.$nextTick();
        listElm.scrollTop = previousScrollTop;
      }
      return true;
    },
    getResponseMessageId(response) {
      const data =
        response && response.data && typeof response.data === "object"
          ? response.data
          : response;
      return (data && (data.id || data.message_id)) || "";
    },
    shouldRefreshAfterSend(roomId, response) {
      if (!roomId || roomId !== this.activeRoomId) {
        return false;
      }
      // Saat fetch histori masih berjalan, respons lama bisa menimpa pesan
      // yang baru muncul. Paksa refresh agar hasil akhirnya kanonis.
      if (this._messageListRequestInFlight > 0) {
        return true;
      }

      const messageId = this.getResponseMessageId(response);
      if (!messageId || messageId === "0" || messageId === "-") {
        return true;
      }
      return !this.hotChatListArr.some(row => {
        return row.id === messageId || row.message_id === messageId;
      });
    },
    async refreshActiveRoomMessages(roomId) {
      if (!roomId || roomId === "new-room" || roomId !== this.activeRoomId) {
        return;
      }

      this._pendingActiveRoomRefresh = roomId;
      if (this._activeRoomRefreshRunning) {
        return;
      }

      this._activeRoomRefreshRunning = true;
      try {
        while (this._pendingActiveRoomRefresh) {
          const targetRoomId = this._pendingActiveRoomRefresh;
          this._pendingActiveRoomRefresh = "";
          if (targetRoomId !== this.activeRoomId) {
            continue;
          }
          await this.reloadActiveRoomMessages(targetRoomId);
        }
      } catch (error) {
        console.log("refresh active room error", error);
      } finally {
        this._activeRoomRefreshRunning = false;
      }
    },
    // scrollToBottom() {
    scrollToBottom() {
      const container = this.$el.querySelector(".chat-wrap-inner");
      if (!container) {
        return;
      }
      this.$nextTick(() => {
        // DOM updated
        // if (setForce == false) {
        container.scrollTop = container.scrollHeight;
        // this.initScrollTop = container.scrollTop;
        // console.log("this.initScrollTop", this.initScrollTop);
        // } else {
        //   container.scrollTop = 300;
        // }
        // container.scrollTop = 100;
        // console.log("container.scrollTop:::", container.scrollTop);
      });
    },

    async getColdChatList(roomId) {
      // this.loading = await true;
      // alert("cold");
      // console.log("coldChat")
      this.hotChatParam.room_id = await roomId;
      this.hotChatParam.keywords = await this.keywords;
      await this.$store
        .dispatch("omniroom/getColdChatList", this.hotChatParam) // sesuai kan dengan method di API
        .then(response => {
          if (this.activeRoomId && this.activeRoomId !== roomId) {
            return;
          }
          // const { data } = response;
          if (response.data.length > 0) {
            this.hotChatListArr.unshift(...response.data.reverse());
            this.changeHotChatListArr(this.hotChatListArr);
            this.hotChatParam.rendered =
              this.hotChatParam.page + response.recordsFiltered;
            this.hotChatParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.hotChatParam.totalRecords = response.totalRecords;
            }

            // this.infiniteHandler(
            //   this.currentState,
            //   this.hotChatParam.rendered,
            //   response.totalRecords
            // );

            this.infiniteHandler(this.currentState, 0, 0);
            this.loading = false;
          }

          // console.log("coldResp", response.data);
          // console.log("coldRespUnshift", this.hotChatListArr);

          // console.log("this.hotChatParam.page", this.hotChatParam.page);
          // console.log("this.hotChatParam.rendered", this.hotChatParam.rendered);
          // console.log("totalRecords::", this.hotChatParam.totalRecords);
        })
        .catch(error => {
          this.loading = false;

          console.log("error", error);
        });
      this.chatContent = await "";
      await this.generateMessage(this.activeRoomId);
    }
  },
  name: "omni"
};
</script>

<style>
/* ============================= CHAT ROOM MODERN ============================= */

.waajo-chat-room {
  background: #f4f6fa;
}

.waajo-chat-room .page-wrapper,
.waajo-chat-room .chat-main-row,
.waajo-chat-room .chat-main-wrapper,
.waajo-chat-room .message-view.task-view {
  background: #f4f6fa;
}

.waajo-chat-room .chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f4f6fa;
}

.waajo-chat-room .fixed-header {
  flex: 0 0 auto;
  padding: 0;
  background: #ffffff;
  border-bottom: 1px solid #eef2f7;
}

.waajo-chat-room .chat-contents {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.waajo-chat-room .chat-content-wrap {
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
  position: relative;
}

.waajo-chat-room .chat-wrap-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.waajo-chat-room .chat-footer {
  flex: 0 0 auto;
  padding: 12px 18px 14px;
  background: #ffffff;
  border-top: 1px solid #eef2f7;
}

/* ============================= HEADER CHAT ============================= */

.waajo-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 72px;
  padding: 12px 18px;
}

.waajo-chat-contact {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.waajo-chat-avatar {
  position: relative;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
}

.waajo-chat-avatar img {
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 14px;
  border: 1px solid #eef2f7;
}

.waajo-online-dot {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 11px;
  height: 11px;
  background: #22c55e;
  border: 2px solid #ffffff;
  border-radius: 50%;
}

.waajo-chat-contact-info {
  min-width: 0;
}

.waajo-chat-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.waajo-chat-name-row h5 {
  max-width: 360px;
  margin: 0;
  overflow: hidden;
  color: #101828;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-channel-badge {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
  padding: 2px 7px;
  color: #067647;
  background: #ecfdf3;
  border: 1px solid #abefc6;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 600;
}

.waajo-chat-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 3px;
  color: #667085;
  font-size: 10px;
}

.waajo-chat-meta i {
  margin-right: 3px;
  color: #f39c12;
}

.waajo-chat-provider {
  text-transform: capitalize;
}

.waajo-chat-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.waajo-chat-search {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 8px 0 10px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.waajo-chat-search > i {
  color: #98a2b3;
  font-size: 11px;
}

.waajo-chat-search input {
  width: 140px;
  height: 100%;
  padding: 0;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 11px;
}

.waajo-chat-search input::placeholder {
  color: #98a2b3;
}

.waajo-chat-search button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 7px;
  font-size: 10px;
  cursor: pointer;
}

.waajo-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  font-size: 14px;
  text-decoration: none;
}

.waajo-header-icon:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
  text-decoration: none;
}

.waajo-header-status {
  position: relative;
}

.waajo-header-status .waajo-status-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 600;
  text-decoration: none;
}

.waajo-header-status .waajo-status-btn:hover {
  color: #8f5600;
  text-decoration: none;
}

.waajo-header-status .waajo-status-btn.is-resolved {
  color: #067647;
  background: #ecfdf3;
  border-color: #abefc6;
}

.waajo-header-status .dropdown-menu {
  min-width: 170px;
  padding: 6px;
  margin-top: 6px;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
}

.waajo-header-status .dropdown-item {
  padding: 7px 9px;
  color: #344054;
  border-radius: 7px;
  font-size: 11px;
}

.waajo-header-status .dropdown-item:hover {
  color: #b36b00;
  background: #fffaf1;
}

/* ============================= EMPTY CHAT ============================= */

.waajo-chat-empty {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 40px 20px;
  text-align: center;
  background: #f4f6fa;
}

.waajo-chat-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 66px;
  height: 66px;
  margin-bottom: 12px;
  color: #f39c12;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 26px;
}

.waajo-chat-empty h4 {
  margin: 0 0 5px;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}

.waajo-chat-empty p {
  max-width: 320px;
  margin: 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.6;
}

/* ============================= MESSAGE AREA ============================= */

.waajo-chat-room .chats {
  padding: 24px 20px 30px;
  background: #f4f6fa !important;
}

.waajo-chat-room .chat-date-group {
  display: block;
  width: 100%;
  min-width: 0;
}

.waajo-chat-room .chat-date-separator-row {
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  flex: 0 0 100%;
  box-sizing: border-box;
  width: 100%;
  margin: 16px 0 12px;
  padding: 0;
  text-align: center;
}

.waajo-chat-room .chat-date-separator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
  padding: 4px 12px;
  overflow: hidden;
  box-sizing: border-box;
  color: #475467;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #e4e7ec;
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  font-size: 10px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-chat-room .chat-message-row {
  display: block;
  width: 100%;
}

.waajo-chat-room .chat-body {
  margin: 4px 0;
  overflow: visible;
}

.waajo-chat-room .chat-left .chat-avatar {
  width: 32px;
  height: 32px;
  margin-top: 5px;
}

.waajo-chat-room .chat-left .chat-avatar img,
.waajo-chat-room .chat-left .chat-avatar .avatar {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
}

.waajo-chat-room .chat-left .chat-body {
  margin-left: 40px;
  padding-right: 12%;
}

.waajo-chat-room .chat-right .chat-body {
  padding-left: 12%;
  padding-right: 8px;
}

.waajo-chat-room .chat-left .chat-content {
  max-width: 70%;
  padding: 9px 12px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 4px 16px 16px 16px;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
}

.waajo-chat-room .chat-right .chat-content {
  max-width: 70%;
  padding: 9px 12px;
  color: #4a3518;
  background: #fff1de;
  border: 1px solid #f6d49b;
  border-radius: 16px 4px 16px 16px;
  box-shadow: 0 2px 5px rgba(243, 156, 18, 0.08);
}

.waajo-chat-room .chat-content p {
  margin: 0 0 3px;
  font-size: 12px;
  line-height: 1.55;
  word-break: break-word;
}

.waajo-chat-room .chat-content .chat-time {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-chat-room .chat-right .chat-content .chat-time {
  text-align: right;
}

.waajo-chat-room .chat-left .chat-content.img-content,
.waajo-chat-room .chat-right .chat-content.img-content {
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.waajo-chat-room .chat-action-btns {
  display: none;
  align-items: center;
  margin: 2px 4px 8px;
}

.waajo-chat-room .chat-bubble:hover .chat-action-btns {
  display: flex;
}

.waajo-chat-room .chat-action-btns ul {
  display: flex;
  gap: 4px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.waajo-chat-room .chat-action-btns a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  color: #98a2b3;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 7px;
  font-size: 10px;
  text-decoration: none;
}

.waajo-chat-room .chat-action-btns a:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.waajo-chat-room .chat-content .experience-box {
  margin-bottom: 6px;
  padding: 5px 7px;
  background: rgba(15, 23, 42, 0.04);
  border-left: 2px solid #f39c12;
  border-radius: 0 6px 6px 0;
}

.waajo-chat-room .chat-content .experience-list {
  padding: 0;
  margin: 0;
  list-style: none;
}

.waajo-chat-room .chat-content .chat-img-attach img {
  border-radius: 10px;
}

/* ============================= COMPOSER ============================= */

.waajo-composer {
  position: relative;
  width: 100%;
}

.waajo-composer-quick {
  margin-bottom: 7px;
}

.waajo-composer-quick p {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin: 0;
}

.waajo-composer-quick .text-muted {
  color: #98a2b3 !important;
  font-size: 9px;
}

.waajo-composer-quick .badge {
  padding: 3px 8px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 600;
  text-decoration: none;
}

.waajo-composer-quick .badge:hover {
  color: #8f5600;
  background: #ffefd4;
}

.waajo-reply-preview {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 8px 11px;
  margin-bottom: 8px;
  background: #fff7e8;
  border-left: 3px solid #f39c12;
  border-radius: 0 9px 9px 0;
}

.waajo-reply-content {
  flex: 1;
  min-width: 0;
}

.waajo-reply-label {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #b36b00;
  font-size: 10px;
  font-weight: 600;
}

.waajo-reply-content p {
  margin: 2px 0 0;
  overflow: hidden;
  color: #667085;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-reply-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #b42318;
  background: #ffffff;
  border: 1px solid #fecdca;
  border-radius: 6px;
  font-size: 10px;
  cursor: pointer;
}

.waajo-composer-main {
  display: flex;
  align-items: flex-end;
  gap: 9px;
  padding: 7px 7px 7px 13px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 16px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.waajo-composer-main:focus-within {
  background: #ffffff;
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.1);
}

.waajo-message-input {
  flex: 1;
  min-width: 0;
  max-height: 150px;
  min-height: 38px;
  padding: 9px 0;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  box-shadow: none;
  resize: none;
  font-size: 12px;
  line-height: 1.5;
}

.waajo-message-input:focus {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.waajo-message-input::placeholder {
  color: #98a2b3;
}

.waajo-send-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  gap: 6px;
  height: 38px;
  padding: 0 15px;
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(243, 156, 18, 0.22);
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.waajo-send-btn:hover:not(:disabled) {
  background: #e08e0b;
  border-color: #e08e0b;
}

.waajo-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  box-shadow: none;
}

.waajo-composer-toolbar {
  margin-top: 7px;
}

.waajo-composer-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.waajo-emoji-host {
  display: inline-flex;
  align-items: center;
}

.waajo-emoji-host .emoji-wrapper {
  display: inline;
}

.waajo-emoji-host span.send-button {
  display: none !important;
}

.waajo-chat-room .waajo-emoji-host .composer-emoji-popover {
  left: 0 !important;
  bottom: calc(100% + 8px) !important;
  width: 360px !important;
  max-width: calc(100vw - 32px);
  height: 300px !important;
  border-radius: 14px !important;
  z-index: 1055;
}

.waajo-tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 30px;
  height: 30px;
  padding: 0 7px;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}

.waajo-tool-btn:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.waajo-tool-btn img {
  width: 15px;
  height: 15px;
  object-fit: contain;
}

.waajo-format-btn {
  min-width: 28px;
  font-family: Arial, sans-serif;
}

.waajo-tool-divider {
  width: 1px;
  height: 20px;
  margin: 0 2px;
  background: #e7edf5;
}

.waajo-ai-tool {
  margin-left: 2px;
}

.waajo-ai-tool .ant-btn {
  height: 30px;
  padding: 0 9px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-family: inherit !important;
  font-size: 10px;
  font-weight: 600;
}

.waajo-ai-tool .ant-btn:hover {
  color: #8f5600;
  background: #ffefd4;
  border-color: #f6c26b;
}

.waajo-chat-room .ant-dropdown-trigger.waajo-tool-btn {
  border-radius: 8px;
}

@media (max-width: 1199px) {
  .waajo-chat-search {
    display: none;
  }

  .waajo-chat-room .chat-left .chat-body {
    padding-right: 6%;
  }

  .waajo-chat-room .chat-right .chat-body {
    padding-left: 6%;
  }
}

@media (max-width: 767px) {
  .waajo-chat-header {
    padding: 10px 12px;
  }

  .waajo-chat-name-row h5 {
    max-width: 180px;
    font-size: 13px;
  }

  .waajo-channel-badge {
    display: none;
  }

  .waajo-chat-contact {
    min-width: 0;
  }

  .waajo-chat-meta {
    font-size: 9px;
  }

  .waajo-chat-room .chat-footer {
    padding: 9px 10px 10px;
  }

  .waajo-chat-room .chats {
    padding: 16px 10px 20px;
  }

  .waajo-chat-room .chat-left .chat-body {
    margin-left: 36px;
    padding-right: 0;
  }

  .waajo-chat-room .chat-right .chat-body {
    padding-left: 0;
  }

  .waajo-chat-room .chat-left .chat-content,
  .waajo-chat-room .chat-right .chat-content {
    max-width: 88%;
  }

  .waajo-send-btn span {
    display: none;
  }

  .waajo-send-btn {
    width: 38px;
    padding: 0;
  }

  .waajo-composer-tools {
    gap: 4px;
  }

  .waajo-tool-btn {
    min-width: 28px;
    height: 28px;
    padding: 0 6px;
  }
}

.waajo-chat-room .waajo-contact-hidden .chat-profile-view,
.waajo-chat-room .chat-profile-view.waajo-contact-hidden {
  display: none !important;
}

.waajo-chat-room .waajo-contact-hidden .message-view.task-view {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
}

.waajo-chat-room .waajo-header-icon:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.12);
}

@media (max-width: 991.98px) {
  .waajo-chat-room .chat-profile-view.waajo-contact-panel:not(.waajo-contact-hidden) {
    position: fixed;
    top: 60px;
    right: 0;
    bottom: 0;
    z-index: 1050;
    display: block !important;
    width: 320px;
    max-width: 88vw;
    margin: 0;
    box-shadow: -18px 0 40px rgba(15, 23, 42, 0.18);
  }

  .waajo-chat-room .waajo-contact-hidden .message-view.task-view {
    display: table-cell !important;
    width: 100% !important;
  }
}

/* ============================= ATTACHMENTS ============================= */
.waajo-attachment-input {
  display: none;
}

.waajo-attachment-drop-active {
  outline: 2px dashed #f6c26b;
  outline-offset: -7px;
  background: #fffdf8;
}

.waajo-attachment-pick {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  cursor: pointer;
}

.waajo-attachment-pick img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.waajo-attachment-pick span {
  font-size: 10px;
}

.waajo-attachment-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 11px;
  margin-bottom: 10px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.waajo-attachment-summary strong {
  display: block;
  color: #344054;
  font-size: 11px;
}

.waajo-attachment-summary span {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-attachment-summary-badge {
  flex: 0 0 auto;
  padding: 3px 7px;
  color: #15803d;
  background: #ecfdf3;
  border: 1px solid #bbf7d0;
  border-radius: 20px;
  font-size: 9px;
  font-weight: 700;
}

.waajo-attachment-summary-badge.is-over {
  color: #b42318;
  background: #fff1f0;
  border-color: #fecaca;
}

.waajo-attachment-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 0;
  margin: 0 0 10px;
  list-style: none;
}

.waajo-attachment-item {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.waajo-attachment-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  overflow: hidden;
  background: #f8fafc;
  border-radius: 8px;
}

.waajo-attachment-preview img,
.waajo-attachment-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.waajo-attachment-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #b36b00;
  font-size: 19px;
}

.waajo-attachment-info {
  flex: 1;
  min-width: 0;
  padding-top: 1px;
}

.waajo-attachment-name {
  overflow: hidden;
  color: #344054;
  font-size: 10px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-attachment-meta {
  display: flex;
  gap: 7px;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-attachment-edited {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #9a5d00;
  font-weight: 700;
}

.waajo-attachment-actions {
  display: flex;
  align-items: center;
  gap: 3px;
  flex: 0 0 auto;
}

.waajo-attachment-edit {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 26px;
  padding: 0 6px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 7px;
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;
}

.waajo-attachment-edit:hover:not(:disabled) {
  color: #9a5d00;
  background: #fff8ec;
  border-color: #f6c26b;
}

.waajo-attachment-edit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.waajo-attachment-edit .fa {
  font-size: 10px;
}

.waajo-attachment-editor-note {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 9px;
  line-height: 1.35;
}

.waajo-attachment-error {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  color: #b42318;
  font-size: 9px;
  line-height: 1.35;
}

.waajo-attachment-status {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: #b36b00;
  font-size: 9px;
}

.waajo-attachment-status.is-success {
  color: #15803d;
}

.waajo-attachment-remove {
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  padding: 0;
  color: #98a2b3;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 7px;
  cursor: pointer;
}

.waajo-attachment-remove:hover:not(:disabled) {
  color: #b42318;
  background: #fff1f0;
  border-color: #fecaca;
}

.waajo-attachment-remove:disabled {
  opacity: 0.45;
  cursor: wait;
}

.waajo-attachment-caption-hint {
  display: block;
  margin-top: -5px;
  color: #98a2b3;
  font-size: 9px;
}

.waajo-attachment-rules {
  padding: 9px 11px;
  margin-bottom: 0;
  font-size: 9px;
  border-radius: 9px;
}

.waajo-attachment-rules ul {
  margin: 0;
  padding-left: 16px;
}

.waajo-attachment-rules li {
  margin: 2px 0;
}

.waajo-composer-drop-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  color: #b36b00;
  background: rgba(255, 250, 241, 0.94);
  border: 2px dashed #f6c26b;
  border-radius: 12px;
  pointer-events: none;
}

.waajo-composer-drop-overlay .fa {
  font-size: 22px;
}

.waajo-composer-drop-overlay strong {
  font-size: 11px;
}

.waajo-composer-drop-overlay small {
  color: #98a2b3;
  font-size: 9px;
}

.waajo-composer-dragging .waajo-composer-main {
  border-color: #f6c26b;
}

.waajo-media-caption {
  margin: 6px 0 0;
  color: #344054;
  font-size: 11px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

@media (max-width: 575.98px) {
  .waajo-attachment-summary {
    align-items: flex-start;
  }

  .waajo-attachment-item {
    gap: 7px;
  }

  .waajo-attachment-preview {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
  }

  .waajo-attachment-name {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/omni/index.vue